import debounce from 'lodash/debounce';

import { init as initLocationAutocomplete } from './location-page.autocomplete.js';
import { trackFormChange } from './location-page.data-tracking.js';
import { init as initLocationGoogleAutocomplete } from './location-page.google-autocomplete';

export const init = ({ disableLocationPageEvents } = { disableLocationPageEvents: false }) => {
  const $searchForm = $('.js-hero-form');
  if ($searchForm.length === 0) {
    return;
  }
  const $roomTagInput = $searchForm.findOne('[name="room_tag"]');
  const $peopleInput = $searchForm.findOne('.c-hero-form__field__icon--people input');

  if ($peopleInput) {
    $peopleInput.isValid = function () {
      const value = this.val();
      return !Number.isNaN(Number(value)) && value <= 1000000;
    };
  }
  const $eventTypeInput = $searchForm.findAny('#hero-event-type');
  const $locationAutoComplete = $searchForm.findAny('.js-location-autocomplete');

  const tagOnSelectCallback = data => {
    $roomTagInput.val(data.key);

    trackFormChange('tag', data.key);

    setTimeout(() => {
      $('#hero-people').focus();
    });

    if (!disableLocationPageEvents) {
      App.track.event('location_page_interaction', {
        section: 'header',
        element: 'event_tag_slug',
        element_value: data.key,
        interaction: 'change',
      });
    }
  };

  const hasEventTypeField = $eventTypeInput.length === 1;
  let autocomplete;

  const eventTagUnknownWarningEvent = debounce((text) => {
    App.track.event('location_page_interaction', {
      section: 'header',
      element: 'event_tag_slug_unknown_warning',
      element_value: text,
      interaction: 'visible',
    });
  }, 500);

  if (hasEventTypeField) {
    autocomplete = App.es6.shared.tags_autocomplete({
      form: $searchForm,
      validateOnSubmit: true,
      onSelectCallback: tagOnSelectCallback,
      onSearchComplete(text, results) {
        if (!results.length) {
          eventTagUnknownWarningEvent(text);
        }
      },
    }).init();
  }

  const hasLocationAutocompleteField = $locationAutoComplete.length === 1;
  const locationAutocomplete = hasLocationAutocompleteField ? initLocationAutocomplete() : null;

  const hasLocationGoogleAutocompleteField = $searchForm.findAny('.js-google-location-autocomplete').length === 1;
  const locationGoogleAutocomplete = hasLocationGoogleAutocompleteField ? initLocationGoogleAutocomplete() : null;

  App.components.home_search({
    getValidationErrorName() {
      if (!$peopleInput.isValid()) {
        const errorField = document.querySelector('.js-people-error-msg');
        if (errorField) {
          errorField.style.display = 'block';
          $peopleInput.on('input', () => {
            errorField.style.display = 'none';
            $peopleInput.off('input');
          });
          return 'people';
        }
      }

      if (!hasEventTypeField) {
        return null;
      }
      autocomplete.validateIsEmpty();

      if (hasLocationAutocompleteField) {
        locationAutocomplete.validateIsEmpty();
        if (!autocomplete.isValid()) {
          return 'event_type';
        }
        if (!locationAutocomplete.isValid()) {
          return 'location';
        }
        return null;
      }

      if (hasLocationGoogleAutocompleteField) {
        locationGoogleAutocomplete.validateIsEmpty();

        if (!locationGoogleAutocomplete.isValid()) {
          return 'location';
        }
      }

      if (!autocomplete.isValid()) {
        return 'event_type';
      }

      return null;
    },
    disableLocationPageEvents,
  });

  $peopleInput.on('change', (e) => trackFormChange('people', e.target.value));

  document.querySelectorAll('.js-hero-form .js-people-step').forEach((button) => {
    button.addEventListener('click', () => {
      const input = button.closest('.c-hero-form__number').querySelector('input');

      if (Number(button.dataset.step) > 0) {
        input.stepUp();
      } else {
        input.stepDown();
      }

      // stepUp()/stepDown() change the value silently; the validation and tracking listeners need the events
      input.dispatchEvent(new Event('input', { bubbles: true }));
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  });

  $('#hero-people').on('keydown', (event) => {
    if (event.key === 'Enter') {
      $('#hero-location').focus();
    }
  });
};
